/* @generated */

// src/assets/ui-icon/line/emoji-uneasy.tsx
import * as React from "react";
var EmojiUneasyLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m12.715 9.3 1.072.286c-.3.145-.447.44-.447.894 0 .675.325 1 1 1s1-.325 1-1c0-.197-.028-.364-.084-.502l1.284.342.38-1.425-3.825-1.02-.38 1.425Zm-2.502.286 1.072-.286-.38-1.425-3.825 1.02.38 1.425 1.284-.342a1.336 1.336 0 0 0-.084.502c0 .675.325 1 1 1s1-.325 1-1c0-.453-.147-.749-.447-.894Zm1.339 5.283c.48.462.985.754 1.51.856a2.115 2.115 0 0 0 1.425-.222c.763-.41 1.239-1.2 1.459-1.746l-1.391-.562c-.159.393-.455.813-.778.986a.617.617 0 0 1-.43.071c-.165-.032-.42-.142-.756-.465-.487-.467-1.002-.757-1.54-.853a2.247 2.247 0 0 0-1.452.232c-.787.41-1.31 1.195-1.562 1.748l1.364.624c.183-.4.52-.848.89-1.042a.75.75 0 0 1 .496-.086c.176.032.434.141.765.459Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c-2.695 0-4.692.652-6.02 1.98h-.002C4.659 7.309 4 9.304 4 12c0 2.695.652 4.692 1.98 6.02v.002C7.309 19.341 9.31 20 12 20c2.695 0 4.692-.652 6.02-1.98h.002C19.341 16.691 20 14.696 20 12c0-2.695-.652-4.692-1.98-6.02v-.002C16.691 4.659 14.696 4 12 4ZM7.04 7.04C7.984 6.098 9.527 5.5 12 5.5s4.017.602 4.96 1.54c.942.943 1.54 2.486 1.54 4.96 0 2.473-.602 4.017-1.541 4.96-.942.942-2.485 1.54-4.959 1.54-2.468 0-4.017-.602-4.96-1.541C6.098 16.017 5.5 14.474 5.5 12c0-2.473.602-4.017 1.54-4.96Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  EmojiUneasyLine
};
